import Section from '../Sections/Section/Section';

import styles from './NotFound.module.css';

export default function NotFound() {
  return (
    <Section className={styles.section}>
      <h2>404 NOT FOUND</h2>
    </Section>
  );
}
